import React, {useEffect, useState} from "react"

import { Button } from "../../shadCn/components/ui/button"


import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../../shadCn/components/ui/dialog"
import {createComputerRoom, getCurrentApprovalProcess} from "../../api/computerRoom/ComputerRoomService";
import {validationChecker} from "../commonmethod/CommonMethod";
import {handleActiveError, handleActiveToast} from "../sonner/ToastBasic";
import InputBasic from "../input/InputBasic";
import Th_title from "../Th_title";
import ApprovalComponent from "../../packages/settings/approval/new/ApprovalComponent";
import {useDispatch, useSelector} from "react-redux";
import {clearApprovalProcessState, getApprovalProcessSubmitPayload, preloadApprovalProcesses} from "../../packages/settings/approval/shared/approvalProcessStore";



export function ModalComputerRoomWrite({Listener,initialData, isOpen, onClose}) {
    const [inputValue, setInputValue] = useState({}); // 입력된 값 상태 관리

    // 예약 관련 상태 추가
    const [isReservation, setIsReservation] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const dispatch = useDispatch();
    const approvalProcessId = useSelector((state) => state.content.approvalProcess?.id);

    // 외부에서 모달 제어
    useEffect(() => {
        if (isOpen !== null) {
            setIsDialogOpen(isOpen);
        }
    }, [isOpen]);

    // initialData 처리
    useEffect(() => {
        if (isDialogOpen && initialData) {
            setInputValue({
                ...initialData
            });
        }
    }, [isDialogOpen, initialData]);


    useEffect(() => {
        if (isDialogOpen) {
            loadCurrentApprovalProcess();
        }
    }, [isDialogOpen]);


    const loadCurrentApprovalProcess = async () => {
        try {
            const response = await getCurrentApprovalProcess();

            if (response.status === 200 && response.data.approvalProcess?.id) {
                preloadApprovalProcesses(dispatch, {
                    beforeId: response.data.approvalProcess.id,
                });
            } else {
                clearApprovalProcessState(dispatch);
            }
        } catch {
            clearApprovalProcessState(dispatch);
        }
    };

    // 기존 함수 그대로 사용
    const getCurrentDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const handleReservationChange = (checked) => {
        setIsReservation(checked);
        if (checked) {
            setInputValue({
                ...inputValue,
                reservationTime: getCurrentDateTime()
            });
        } else {
            const { reservationTime, ...rest } = inputValue;
            setInputValue(rest);
        }
    };




    const create = async()=>{

        if (initialData) {
            const requiredFields = ['affiliation', 'position', 'name', 'phoneNumber', 'visitLocation', 'visitPurpose'];
            const missingFields = requiredFields.filter(field => !inputValue[field] || inputValue[field].trim() === '');

            if (missingFields.length > 0) {
                alert(`필수값이 누락되었습니다.`);
                return;
            }
        } else {
            // 새로 작성할 때만 기존 validation 사용
            if(!validationChecker(inputValue)) {
                return;
            }
        }

        // ✅ 전화번호 형식 검증 추가
        if (inputValue.phoneNumber) {
            const phoneRegex = /^\d{3}\d{3,4}\d{4}$/;
            if (!phoneRegex.test(inputValue.phoneNumber)) {
                handleActiveError({message: "등록실패", description: "전화번호 형식이 올바르지 않습니다."});
                return;
            }
        }


        if (isReservation) {
            const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
            if (!dateRegex.test(inputValue.reservationTime)) {
                alert("올바른 형식으로 입력해주세요 (YYYY-MM-DD hh:mm:ss)");
                return;
            }

            // ✅ 과거 시간 검증 추가 (이 부분만 추가)
            const selectedDateTime = new Date(inputValue.reservationTime);
            const currentDateTime = new Date();

            if (selectedDateTime <= currentDateTime) {
                alert("예약 시간은 현재 시간보다 이후여야 합니다.");
                return;
            }
        }

        const requestData = {
            ...inputValue,
            checkInAt: isReservation ? inputValue.reservationTime : null,
            ...getApprovalProcessSubmitPayload(),
        };
        const response = await createComputerRoom(requestData);

        if(response && response.status===200) {

            handleActiveToast({message: "등록되었습니다.", labelListener:()=>{}});
            // dispatch(refresh(true));
            setInputValue({});
            setInputValue({required_validate: {affiliation: false, position: false, name: false, phoneNumber: false, visitLocation: false, visitPurpose: false}});

            // ✅ 예약 관련 상태 초기화 추가
            setIsReservation(false);
            Listener();

            // navigate(`/computerroom/create`)
        }
        else if (response && response.status === 400) {
            handleActiveError({message: "등록실패", description: response.data.reason});
            return;
        }
    }


    const handleDialogOpenChange = (open) => {
        setIsDialogOpen(open);

        if (!open) {
            setInputValue({});
            setIsReservation(false);
            clearApprovalProcessState(dispatch);
            if (onClose) onClose();
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={handleDialogOpenChange}>
            <DialogTrigger asChild>
                <Button variant="destructive" className="w-min bg-[var(--main-bg-color)] hover:bg-[var(--main-label-color)] text-center">전산실 출입
                    작성</Button>
            </DialogTrigger>
            <DialogContent className="h-[40rem] w-[40rem] max-w-[40rem] overflow-scroll">
                <DialogHeader>
                    <div className="flex items-center justify-between">
                    <DialogTitle>전산실 출입 작성</DialogTitle>

                        <div className="flex items-center space-x-2 mt-3">
                            <input
                                type="checkbox"
                                id="reservation-checkbox"
                                checked={isReservation}
                                onChange={(e) => handleReservationChange(e.target.checked)}
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                            />
                            <label
                                htmlFor="reservation-checkbox"
                                className="text-sm font-medium text-gray-700 cursor-pointer select-none"
                            >
                                예약입실
                            </label>
                        </div>
                    </div>


                </DialogHeader>

                <table className="w-full h-[300px] create-table">
                    <tbody>

                    <tr>
                        <Th_title title={"소속"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"affiliation"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"직위"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"position"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"성명"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"name"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"연락처"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"phoneNumber"}
                                data={{data: inputValue, setData: setInputValue}}
                                placeholder={"01012341234"}
                            />
                        </Th_title>
                    </tr>
                    <tr>
                        <Th_title title={"방문 위치"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"visitLocation"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>

                    <tr>
                        <Th_title title={"방문 목적"} className="fieldset-td" colspan={2} required={true}>
                            <InputBasic
                                target={"visitPurpose"}
                                data={{data: inputValue, setData: setInputValue}}
                            />
                        </Th_title>
                    </tr>



                    {/* 예약 시간 입력 필드 (조건부 렌더링) */}
                    {isReservation && (
                        <tr>
                            <Th_title title={"입실 시간"} className="fieldset-td" colspan={2} required={true}>
                                <InputBasic
                                    target={"reservationTime"}
                                    data={{data: inputValue, setData: setInputValue}}
                                />
                            </Th_title>
                        </tr>
                    )}





                    </tbody>
                </table>

                <ApprovalComponent auth approvalProcessId={approvalProcessId}/>

                <div className="flex item-center space-x-2">

                    <Button type="button" variant="outline" className="border-current" onClick={create}>
                        작성완료
                    </Button>


                </div>

            </DialogContent>
        </Dialog>
    );

}
